/**
 * Variantes disponibles para el componente BordStatus
 */
export const STATUS_VARIANTS = {
  default: 'default',
  informative: 'informative',
  success: 'success',
  danger: 'danger',
  alert: 'alert'
} as const;

export type statusVariants = typeof STATUS_VARIANTS[keyof typeof STATUS_VARIANTS];
